var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var dagPB = require('ipld-dag-pb');

var defaultBase = 'base58btc';

var cidifyString = function cidifyString(str) {
  if (!str) {
    return str;
  }

  if (Array.isArray(str)) {
    return str.map(cidifyString);
  }

  return new CID(str);
};

var stringifyCid = function stringifyCid(cid, options) {
  if (!cid || typeof cid === 'string') {
    return cid;
  }

  if (Array.isArray(cid)) {
    return cid.map(stringifyCid);
  }

  if (cid['/']) {
    return cid['/'];
  }

  var base = options.base || defaultBase;
  return cid.toBaseEncodedString(base);
};

var writePb = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfs, obj, options) {
    var buffer, dagNode, cid, res, pin;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            buffer = Buffer.from(JSON.stringify(obj));
            dagNode = new dagPB.DAGNode(buffer);
            _context.next = 4;
            return ipfs.dag.put(dagNode, {
              format: 'dag-pb',
              hashAlg: 'sha2-256'
            });

          case 4:
            cid = _context.sent;
            res = cid.toV0().toBaseEncodedString();
            pin = options.pin || false;

            if (!pin) {
              _context.next = 10;
              break;
            }

            _context.next = 10;
            return ipfs.pin.add(res);

          case 10:
            return _context.abrupt("return", res);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function writePb(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var readPb = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ipfs, cid) {
    var result, dagNode;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return ipfs.dag.get(cid);

          case 2:
            result = _context2.sent;
            dagNode = result.value;
            return _context2.abrupt("return", JSON.parse(dagNode.toJSON().data));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function readPb(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var writeCbor = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ipfs, obj, options) {
    var dagNode, links, base, onlyHash, cid, res, pin;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            dagNode = Object.assign({}, obj);
            links = options.links || [];
            links.forEach(function (prop) {
              if (dagNode[prop]) {
                dagNode[prop] = cidifyString(dagNode[prop]);
              }
            });
            base = options.base || defaultBase;
            onlyHash = options.onlyHash || false;
            _context3.next = 7;
            return ipfs.dag.put(dagNode, {
              onlyHash: onlyHash
            });

          case 7:
            cid = _context3.sent;
            res = cid.toBaseEncodedString(base);
            pin = options.pin || false;

            if (!pin) {
              _context3.next = 13;
              break;
            }

            _context3.next = 13;
            return ipfs.pin.add(res);

          case 13:
            return _context3.abrupt("return", res);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function writeCbor(_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

var readCbor = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ipfs, cid, options) {
    var result, obj, links;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return ipfs.dag.get(cid);

          case 2:
            result = _context4.sent;
            obj = result.value;
            links = options.links || [];
            links.forEach(function (prop) {
              if (obj[prop]) {
                obj[prop] = stringifyCid(obj[prop], options);
              }
            });
            return _context4.abrupt("return", obj);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function readCbor(_x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();

var writeObj = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ipfs, obj, options) {
    var onlyHash, base, opts, cid, res, pin;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            onlyHash = options.onlyHash || false;
            base = options.base || defaultBase;
            opts = Object.assign({}, {
              onlyHash: onlyHash
            }, options.format ? {
              format: options.format,
              hashAlg: 'sha2-256'
            } : {});

            if (opts.format === 'dag-pb') {
              obj = new dagPB.DAGNode(obj);
            }

            _context5.next = 6;
            return ipfs.dag.put(obj, opts);

          case 6:
            cid = _context5.sent;
            res = cid.toBaseEncodedString(base);
            pin = options.pin || false;

            if (!pin) {
              _context5.next = 12;
              break;
            }

            _context5.next = 12;
            return ipfs.pin.add(res);

          case 12:
            return _context5.abrupt("return", res);

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function writeObj(_x12, _x13, _x14) {
    return _ref5.apply(this, arguments);
  };
}();

var formats = {
  'dag-pb': {
    read: readPb,
    write: writePb
  },
  'dag-cbor': {
    write: writeCbor,
    read: readCbor
  },
  'raw': {
    write: writeObj
  }
};

var write = function write(ipfs, codec, obj) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var format = formats[codec];
  if (!format) throw new Error('Unsupported codec');
  return format.write(ipfs, obj, options);
};

var read = function read(ipfs, cid) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  cid = new CID(cid);
  var format = formats[cid.codec];
  if (!format) throw new Error('Unsupported codec');
  return format.read(ipfs, cid, options);
};

module.exports = {
  read: read,
  write: write
};